import React from "react";
import { Button, Link, MenuItem, Stack } from "@mui/material";
import { useNavigate, useOutletContext } from "react-router-dom";


import { useDispatchWrapper } from "../../../../../../hooks";
import { IStoreState } from "../../../../../../redux/initialStoreState";
import { useSelector } from "react-redux";
import { LoadState } from "../../../../../../constants/enums";
import { StandardTableActions } from "../../../../../../components/StandardTableActions/StandardTableActions";
import {
  clearHabitationalApplicationState,
  downloadHabitationalPDFApplications,
  fetchHabitationalApplicationListAsync,
  previewHabitationalPDFApplications,
} from "../../../../../../redux/habitationalPolicy/habitationalApplication/habitationalApplication.Actions";
import { IHabitationalApplication } from "../../../../../../redux/habitationalPolicy/habitationalApplication/habitationalApplicationNew.types";
import { useTableV2State } from "../../../../../../components/TableV2/hooks/useTableV2State";
import {
  DataTableV2RowRenderType,
  IDataTableV2Props,
} from "../../../../../../components/TableV2/interfaces/IDataTableV2Props";
import { PageTitleBar } from "../../../../../../components/PageTitleBar/PageTitleBar";
import { AddOutlined, HistoryEdu, RequestQuote } from "@mui/icons-material";
import { DataTableV2 } from "../../../../../../components/TableV2/DataTableV2";
import { StatusRenderer } from "../../../../../../components/ActiveInActiveStatus/ActiveInActiveStatus";
import { CustomSelect } from "../../../../../../components/formsComponents";
import { ARSQuoteDialog } from "../../AutomobilePolicy/AutomobileApplicationForm/ARSQuote";
import { PageContainer } from "../../../../../../components/container/PageContainer";
import { formatText } from "../../../../../../helpers";
import { HabitationalApplicationG4SignDialog } from "../HabitationalG4Sign/HabitationalApplicationG4SignDialog";

export const HabitationalApplicationList = () => {
  const data1 = useOutletContext() as any;
  const customerId = data1[0];
  const customerpolicyId = data1[1];
  const navigate = useNavigate();
  const [openFile, setOpenFile] = React.useState(false);
  const [g4SignApp, setG4SignApp] = React.useState<IHabitationalApplication | null>(null);
  const { list, loading } = useSelector(
    (storeState: IStoreState) => storeState.habitational.applications
  );
  const dispatch = useDispatchWrapper();

  const [status, setStatus] = React.useState<"ACTIVE" | "INACTIVE" | "-1">(
    "ACTIVE"
  );

  const {
    state: { dateState, searchState, tabs, columnsConfig,
      dense },
    setDateState,
    setSelectedTab,
    setTableTabs,
    setSearchState,
    setColumnVisibility,
 
    onDenseToggle, } = useTableV2State({
    filtersInitialState: {
      defaultDateRange: "last28Days",
      selectedTab: "-1",
    },
  });

  const handleCreate = () => {
    navigate(
      `/habitational-policy/${customerId}/application-tab/${customerpolicyId}/application`
    );
  };

  const fetchList = () => {
    if (customerpolicyId) {
      dispatch(fetchHabitationalApplicationListAsync(customerpolicyId, status));
    }
  };

  React.useEffect(() => {
    fetchList();

    return () => {
      dispatch(clearHabitationalApplicationState());
    };
  }, [customerpolicyId, status]);

  const handleComplete = () => {
    fetchList();
    setOpenFile(false);
  };

  const habitationalApplicationTableProps: IDataTableV2Props = {
    isPagination: false,
    isDataLoading: loading === LoadState.InProgress,
    tableCommandBarProps: {
      preDefinedPlugins: {
        columnVisibility: {
          columnVisibility: columnsConfig.columnVisibility,
          onChange: setColumnVisibility,
        },
        refresh: {
          onClick: fetchList,
        },
      },
      leftItems: {},
      rightItems: {
        customPlugins: [
          {
            key: "status",
            onRender: () => (
              <CustomSelect
                sx={{ minWidth: "120px" }}
                value={status}
                onChange={(e) => setStatus(e.target.value as "ACTIVE")}
              >
                {" "}
                {/* <MenuItem value="-1">All Status</MenuItem> */}
                <MenuItem value="ACTIVE">Active</MenuItem>
                <MenuItem value="INACTIVE">Inactive</MenuItem>
              </CustomSelect>
            ),
          },
        ],
      },
    },
    masterColumns: [
      {
        key: "view",
        headerName: "Actions",
        headingAlign: "center",
        fieldName: "",
        renderType: DataTableV2RowRenderType.CUSTOM_RENDER,
        onRowCellRender: (value, row: IHabitationalApplication) => {
          return (
            <StandardTableActions
              onEditClick={() => {
                navigate(
                  `/habitational-policy/${customerId}/application-tab/${customerpolicyId}/application/${row.incremental_number}`
                );
              }}
              onDownLoadClick={() => {
                dispatch(
                  downloadHabitationalPDFApplications(
                    customerpolicyId,
                    row.incremental_number!
                  )
                );
              }}
              onDownloadPreview={() => {
                dispatch(
                  previewHabitationalPDFApplications(
                    customerpolicyId,
                    row.incremental_number!
                  )
                );
              }}
              otherActions={[
                {
                  icon: HistoryEdu,
                  tooltip: "G4Sign",
                  onClick: () => {
                    setG4SignApp(row);
                  },
                },
              ]}
            />
          );
        },
      },
      {
        key: "status",
        headerName: "Status",
        fieldName: "status",
        enableSorting: true,
        renderType: DataTableV2RowRenderType.CUSTOM_RENDER,
        onRowCellRender: (value, row: IHabitationalApplication) => {
          return <StatusRenderer status={row.status} />;
        },
      },
      {
        key: "incremental_number",
        headerName: "Loc #",
        fieldName: "incremental_number",
        renderType: DataTableV2RowRenderType.TEXT_DARK,
        // exportCellWidth: 15,
      },

      // {
      //   key: "address",
      //   headerName: "Address",
      //   fieldName: "address",
      //   renderType: DataTableV2RowRenderType.TEXT,
      // exportCellWidth: 30,
      //   onRowCellValueRender: (value, row: IHabitationalApplication) => {
      //     return (
      //       row.applicant_details +
      //       ", " +
      //       row.applicant_unit_or_suite +
      //       ", " +
      //       row.applicant_city +
      //       ", " +
      //       row.applicant_province_or_state +
      //       ", " +
      //       row.applicant_postal_or_zip_code
      //     );
      //   },
      // },

      {
        key: "policy_number",
        headerName: "Policy No.",
        fieldName: "policy_number",
        renderType: DataTableV2RowRenderType.TEXT,
        // exportCellWidth: 20,
      },
      {
        key: "applicant_name",
        headerName: "Applicant Name",
        fieldName: "applicant_name",
        renderType: DataTableV2RowRenderType.CHIP_WARNING,
        // exportCellWidth: 20,
        onRowCellRender: (value, row: IHabitationalApplication) => {
          return (
            <Link
              sx={{ cursor: "pointer" }}
              onClick={() =>
                navigate(
                  `/habitational-policy/${customerId}/application-tab/${customerpolicyId}/application/${row.incremental_number}`
                )
              }
            >
              {row.applicant_details.applicant_name}
            </Link>
          );
        },
      },
      {
              key: "application_type",
              headerName: "Application Type",
              fieldName: "application_type",
              renderType: DataTableV2RowRenderType.CUSTOM_RENDER,
              // exportCellWidth: 30,
              onRowCellValueRender: (value, row) => {
                return formatText(value);
              },
            },
      {
        key: "policy_period_effective_date",
        headerName: "Effective Date",
        fieldName: "policy_period_effective_date",
        renderType: DataTableV2RowRenderType.DATE,
        // exportCellWidth: 20,
      },
    ],
    rows: list,
      dense: dense,
    onDenseToggle: onDenseToggle,};

  return (
    <PageContainer title="Habitational Application" description="this is innerpage">
      <PageTitleBar
        heading="Application"
        rightHeading={
          <Stack direction={"row"} spacing={1}>
            {/* <Button
              variant="contained"
              onClick={() => {
                setOpenView({
                  ...INITIAL_QUICK_APPLICATION,
                });
              }}
            >
              Quick Create
            </Button> */}
            <Button
              variant="contained"
              onClick={() => 
                navigate(`/habitational-policy/${customerId}/application-tab/${customerpolicyId}/quote-ars`)
              }
              endIcon={<RequestQuote />}
            >
              Create From ARS Quote
            </Button>
            <Button
              variant="contained"
              onClick={handleCreate}
              startIcon={<AddOutlined />}
            >
              Create
            </Button>
          </Stack>
        }
      />
      <DataTableV2 {...habitationalApplicationTableProps} />
      {openFile && (
        <ARSQuoteDialog
          open={openFile}
          onComplete={handleComplete}
          type={"habitational"}
          customerId={customerId}
          customerPolicyId={customerpolicyId}
          onClose={() => setOpenFile(false)}
        />
      )}

      {g4SignApp && (
        <HabitationalApplicationG4SignDialog
          open={true}
          applicationNumber={g4SignApp.incremental_number!}
          applicationType={(g4SignApp as any).application_type || "habitational"}
          customerPolicyId={customerpolicyId}
          customerId={customerId}
          onClose={() => setG4SignApp(null)}
        />
      )}
      </PageContainer>
  );
};
